const projects = [
  {
    name: "Bliss Nails and Spa",
    description: "Marketing page for a full-service nail salon.",
    technologies:
      "React, Bootstrap",
    repository: "",
    deployed: "https://www.blissnas.com",
    image: "bliss.png",
    imageAlt: "screenshot of Bliss Nails and Spa marketing page",
    gif: "",
  },
  {
    name: "Roam",
    description: "An application for facilitating group travel.  Allows for managing trips, shared expenses, and tasks.",
    technologies:
      "React, Bulma, Node Sass, moment.js, react-router-dom, Figma, CSS Animations, React-dates, Chart.js, jsonwebtoken, Express, Node.js, MongoDB, MongoDB Atlas, Mongoose, Axios, Cookie-parser,  Express File Upload, bcrypt, dotenv, Google Places API, Cloudinary",
    repository: "https://github.com/pkriengsiri/roam",
    deployed: "https://www.roam-together.com",
    image: "roam.png",
    imageAlt: "screenshot of Roam application",
    gif: "",
  },
  {
    name: "Bird Brains",
    description: "A gamified bird-watching application",
    technologies:
      "HTML, CSS, JavaScript, jQuery, Materialize, Font-Awesome, Slick, Cloudinary API, Node.js, Express, Express Handlebars, Sequelize, ES Lint, Moment",
    repository: "https://github.com/pkriengsiri/bird-brains",
    deployed: "https://www.bird-brains.com",
    image: "bird.png",
    imageAlt: "screenshot of Bird Brains application",
    gif: "",
  },
  {
    name: "What's in the Box?",
    description:
      "An application for tracking the context of boxes packed for household moving and storage projects",
    technologies:
      "HTML, CSS, JavaScript, jQuery, BootStrap, Font-Awesome, jQuery QR code library, paste.ee API, html2pdf API, orghunter charity search API, google maps API",
    repository: "https://github.com/pkriengsiri/whats-in-the-box",
    deployed: "https://pkriengsiri.github.io/whats-in-the-box/",
    image: "box.png",
    imageAlt: "screenshot of What's in the Box? application",
    gif: "",
  },
  {
    name: "Burger Eater!",
    description: "A full-stack burger eating simulator",
    technologies:
      "HTML, CSS, JavaScript, BootStrap, Node.js, Express, Express Handlebars, MySQL, custom ORM",
    repository: "https://github.com/pkriengsiri/burger-eater",
    deployed: "https://burger-experience.herokuapp.com/",
    image: "burger.png",
    imageAlt: "screenshot of Burger Eater application",
    gif: "",
  },
  {
    name: "Employee Tracker",
    description: "A command-line CMS for managing employee data",
    technologies: "Node.js, MySQL, Inquirer",
    repository: "https://github.com/pkriengsiri/employee-tracker",
    deployed: "",
    image: "employee.png",
    imageAlt: "screenshot of Employee Tracker application",
    gif: "",
  },
  {
    name: "Note Taker",
    description:
      "An app for creating, saving, editing and deleting plain text notes.",
    technologies: "HTML, CSS, JavaScript, jQuery, BootStrap, Node.js, Express",
    repository: "https://github.com/pkriengsiri/note-taker",
    deployed: "https://note-taker-dpk.herokuapp.com/",
    image: "note.png",
    imageAlt: "screenshot of Note Taker application",
    gif: "",
  },
  {
    name: "Weather Dashboard",
    description:
      "A weather dashboard that displays the weather outlook for multiple cities using the OpenWeather API",
    technologies:
      "HTML, CSS, Bootstrap CSS Framework, JavaScript, jQuery, and the font-awesome icon pack",
    repository: "https://github.com/pkriengsiri/weather-dashboard",
    deployed: "https://pkriengsiri.github.io/weather-dashboard/",
    image: "weather.png",
    imageAlt: "screenshot of Weather Dashboard application",
    gif: "",
  },
  {
    name: "Coding Quiz Challenge",
    description:
      "An HTML-based coding quiz game, dynamically updated and tracked using DOM manipulation and local storage",
    technologies: "HTML, CSS, Bootstrap CSS Framework, and JavaScript",
    repository: "https://github.com/pkriengsiri/code-quiz-game",
    deployed: "https://pkriengsiri.github.io/code-quiz-game/",
    image: "quiz.png",
    imageAlt: "screenshot of Coding Quiz Challenge application",
    gif: "",
  },
  {
    name: "Workday Planner",
    description:
      "A simple workday planning application using HTML, CSS and jQuery",
    technologies: "HTML, CSS, JavaScript, jQuery, Font Awesome",
    repository: "https://github.com/pkriengsiri/workday-planner",
    deployed: "https://pkriengsiri.github.io/workday-planner/",
    image: "planner.png",
    imageAlt: "screenshot of Workday Planner application",
    gif: "",
  },
  {
    name: "Password Generator",
    description:
      "A simple password generator which uses modal windows to solicit the user's parameters for the password, and generates a random password based upon the user selections.",
    technologies: "HTML, CSS, JavaScript",
    repository: "https://github.com/pkriengsiri/password-generator",
    deployed: "https://pkriengsiri.github.io/password-generator/",
    image: "password.png",
    imageAlt: "screenshot of the Password Generator application",
    gif: "",
  },
];

export default projects;
